import React from 'react';
import { GlobalStyles, SYS_COLOR_CANVAS_DEFAULT_DARK, SYS_COLOR_CANVAS_INVERTED_DARK, SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK, SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT, ThemeProvider, } from '@oneaudi/unified-web-common';
import { GlobalStyles as AlphaGlobalStyles, SYS_COLOR_CANVAS_200_DARK, SYS_COLOR_CANVAS_200_LIGHT, SYS_GRADIENT_SURFACE_INTERACTIVE_PRIMARY_100_DARK, SYS_GRADIENT_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT, } from '@oneaudi/unified-web-alpha-common';
export const DynamicThemeProviderWrapper = ({ children }) => {
    return (React.createElement(ThemeProvider, { theme: {
            iconBasePath: 'icons',
            name: process.env.IS_LEGACY || process.env.IS_LEGACY === undefined ? 'light' : 'dark',
        } }, children));
};
export const DynamicGlobalStyles = () => {
    return process.env.IS_LEGACY || process.env.IS_LEGACY === undefined ? (React.createElement(GlobalStyles, null)) : (React.createElement(AlphaGlobalStyles, { hasGlobalBackgroundColor: true, themeName: "dark" }));
};
export const GetSafeColorDesignToken = (color) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        if (color === 'dark') {
            return SYS_COLOR_CANVAS_DEFAULT_DARK;
        }
        if (color === 'inverted') {
            return SYS_COLOR_CANVAS_INVERTED_DARK;
        }
        if (color === 'interactive-light') {
            return SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT;
        }
        if (color === 'interactive-dark') {
            return SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK;
        }
    }
    if (color === 'inverted') {
        return SYS_COLOR_CANVAS_200_LIGHT;
    }
    if (color === 'interactive-light') {
        return SYS_GRADIENT_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT;
    }
    if (color === 'interactive-dark') {
        return SYS_GRADIENT_SURFACE_INTERACTIVE_PRIMARY_100_DARK;
    }
    return SYS_COLOR_CANVAS_200_DARK;
};
export const dynamicStylingHelper = (unifiedStylingInput, alphaStylingInput) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined)
        return unifiedStylingInput;
    return alphaStylingInput !== null && alphaStylingInput !== void 0 ? alphaStylingInput : '';
};
export const getDesignLibrary = (props) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return {
            '@oneaudi/unified-web-common': (props === null || props === void 0 ? void 0 : props.unifiedWebCommonVersion) || '*',
        };
    }
    return {
        '@oneaudi/unified-web-alpha-common': (props === null || props === void 0 ? void 0 : props.unifiedWebAlphaCommonVersion) || '*',
    };
};
